module.exports = __webpack_public_path__ + "img/Twitter@3x.bfddff3f.svg";